import API, { config } from './_main';
import * as POIModule from './../Modules/POIModule';

export function getPOIList(userId?: number) {
    return API.get('domain-of-interest/poi', config());
}

export function addPOI(poiData: POIModule.Types.AddPointOfInterestRequest) {
    return API.post('domain-of-interest/poi', poiData, config());
}

export function deletePOI(poiID: number) {
    return API.delete(`domain-of-interest/poi/${poiID}`, config());
}

export function updatePoi(poiData: POIModule.Types.UpdatePointOfinterestRequest, poiId: number) {
    return API.put(`domain-of-interest/poi/${poiId}`, poiData, config());
}

export function getPOIByLatLon(lat: number,lon:number) {
    return API.get('nominatim/address-display-name', config({lat,lon}));
}



// WEBPACK FOOTER //
// ./src/Connectors/POIConnector.ts